import { useCallback, useEffect, useState } from 'react';
import CircleLoader from '../../../../plug/CircleLoader';
import FormInput from '../../form-input/FormInput/FormInput';
import css from './SelectDataGrid.module.scss';
import classNames from 'classnames';
import { generateCompStylers } from '../../../../../common/utils/styles';
import SearchWindow from '../../../../searchWindow/SearchWindow';
import GridComponent from '../../../../grid/GridComponent/GridComponent';

const SelectDataGrid = (props) => {
    const { value, customData, placeholder, handlers, buttons, compStyle, setFormData, attribute, variationStyle } = props;
    const [selectedData, setSelectedData] = useState([]);
    // const selectedIds = useMemo(() => selectedData?.map((elem) => elem.id), [selectedData]);
    const selectedIds = customData?.selectedIds;

    const [showSponsor, setShowSponsor] = useState(false);
    const [gridData, setGridData] = useState({ thead: customData?.gridThead, tbody: customData?.transformGridData(value) });

    useEffect(() => {
        if (customData?.setSelectedIds && Array?.isArray(value)) {
            customData?.setSelectedIds(value?.map((el) => el?.id));
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [value, showSponsor]);

    const { stylers, classes } = generateCompStylers(compStyle);

    const confirmSelect = useCallback(
        (dataToSend, setAllowedSend) => {
            const newValue = [];
            const unionOfData = [...value, ...selectedData];
            for (const item of unionOfData) {
                const isInNewValue = newValue?.find((it) => it?.id === item?.id);
                if (isInNewValue) {
                    continue;
                } else {
                    newValue?.push(item);
                }
            }
            setAllowedSend(true);
            setFormData(attribute, newValue);
            setShowSponsor(false);
        },
        [selectedData, value, attribute, setFormData]
    );

    const activeHandler = useCallback(
        (item) => {
            if (customData?.setSelectedIds) {
                customData?.setSelectedIds((s) => {
                    const normalizedState = s?.map(Number);
                    const elementInState = normalizedState?.includes(Number(item?.id));
                    if (elementInState) {
                        return normalizedState?.filter((el) => el !== Number(item?.id));
                    } else {
                        return [...s, item?.id];
                    }
                });
            }
            setSelectedData((s) => {
                const elementInState = s?.find((el) => el?.id === item?.id);
                if (elementInState) {
                    return s?.filter((el) => el?.id !== item?.id);
                } else {
                    return [...s, item];
                }
            });
        },
        [customData]
    );

    useEffect(() => {
        setGridData((s) => ({
            ...s,
            tbody: customData?.transformGridData(value)
        }));
    }, [value, customData]);

    useEffect(() => {
        setSelectedData([]);
    }, [showSponsor]);

    const closeHandler = () => {
        setSelectedData([]);
        setShowSponsor(false);
        if (customData?.setSelectedIds) {
            customData?.setSelectedIds([]);
        }
    };

    return (
        <>
            <div className={css.wrapper}>
                <FormInput
                    {...props}
                    placeholder={customData?.loading ? <CircleLoader /> : placeholder}
                    handlers={{
                        ...(handlers || {}),
                        onClick: () => setShowSponsor(true)
                    }}
                    buttons={{
                        icon: { icon: customData?.icon || 'user' },
                        ...(buttons || {})
                    }}
                    value={null}
                    readonly={true}
                    compStyle={{
                        ...compStyle,
                        placeholderWrapper: { cursor: 'inherit' },
                        input: {
                            ...stylers.input,
                            className: classNames(
                                css.input,
                                customData?.helpButtons ? css.formSelectDataInput : '',
                                classes.input
                            )
                        },
                        title: {
                            ...stylers.title,
                            className: classNames(
                                customData?.helpButtons && variationStyle !== 'couple_title' ? css.formSelectDataTitle : '',
                                classes.title
                            )
                        }
                    }}
                />
                <GridComponent
                    viewThead={gridData?.thead}
                    viewData={gridData?.tbody}
                    handlers={customData?.gridHandlers}
                    gridStyles={customData?.gridStyles}
                />
            </div>
            {showSponsor ? (
                <SearchWindow
                    input={customData?.modalInput || {}}
                    closeModal={closeHandler}
                    transformSearchData={customData?.transformSearchData || null}
                    sendData={{ url: customData?.url }}
                    title={customData?.modalTitle}
                    thead={customData?.thead}
                    selectedIds={selectedIds}
                    customStyle={{
                        ...compStyle,
                        searchWindowWrapper: css.searchWindowWrapper
                    }}
                    customData={{ ...customData?.buttons }}
                    okHandler={{ sender: confirmSelect }}
                    gridHandlers={{ active: { change: { onChange: activeHandler } } }}
                    gridConfig={{ fullScreen: false }}
                />
            ) : null}
        </>
    );
};

export default SelectDataGrid;
